import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import { defineComponent as _defineComponent } from 'vue';
import CardRatingAndReviews from './CardRatingAndReviews.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import { useUser } from '~/composables/_next/useUser';
import { useSkeepers } from '~/composables/_next/useSkeepers';
import { useGetTranslations } from '@/composables/useGetTranslations';
import { loadScript, openModal } from '~/helpers/reviewsRating';
import { convertLocaleEnToUk } from '~/helpers/convertEnToUk';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { useAuthenticatedAction } from '~/composables/useAuthenticatedAction';
import { useLocalization } from '~/composables/_next/useLocalization';
export default /*#__PURE__*/_defineComponent({
  __name: 'RatingReviews',
  props: {
    consumerAdvices: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    totalItems: {
      type: Number,
      default: 0
    },
    ratings: {
      type: Number,
      default: 0
    },
    idProduct: {
      type: String,
      default: ''
    },
    nameProduct: {
      type: String,
      default: ''
    },
    idForAnchor: {
      type: String,
      default: 'rating-reviews-section-title'
    },
    skus: {
      type: String,
      default: ''
    }
  },
  emits: ['update-current-page'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useSkeepers = useSkeepers(),
      loadSkeepers = _useSkeepers.loadSkeepers,
      generateWidget = _useSkeepers.generateWidget;
    var route = useRoute();
    var _useAuthenticatedActi = useAuthenticatedAction(),
      doActionOrLogin = _useAuthenticatedActi.doActionOrLogin;
    var _useNuxt2App = useNuxt2App(),
      $flag = _useNuxt2App.$flag;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    var isClientReady = ref(false);
    var _useUser = useUser(),
      user = _useUser.user;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var date = new Date();
    var nameOfPage = route.name;
    var tokenWidgets = process.env.AVIS_VERIFIES_WIDGETS_TOKEN;
    var isMainNewReviewEnabled = $flag.get('isEnabledMainNewReview');
    var isReviewWidgetDisplayed = ref(false);

    /**
     * Check if a key exists anywhere in the string.
     *
     * @param {string} key - The key to check for existence.
     * @returns {boolean} - True if the key exists, false otherwise.
     */
    function verifyKeyExists(key) {
      return nameOfPage.includes(key);
    }

    // initializing false for ssr
    var isSkeeperLoaded = ref(false);
    var skeepersWidget = ref(null);
    var formattedDate = ref(formatDate(date));
    var isNotEmpty = computed(function () {
      var _props$consumerAdvice;
      return ((_props$consumerAdvice = props.consumerAdvices) === null || _props$consumerAdvice === void 0 ? void 0 : _props$consumerAdvice.length) > 0;
    });
    var isPageIncluded = computed(function () {
      var requiredKeys = ['legacy-Recipe-slug', 'legacy-Advice-slug'];
      return requiredKeys.some(function (key) {
        return verifyKeyExists(key);
      });
    });
    var firstName = computed(function () {
      var _user$value;
      return user === null || user === void 0 ? void 0 : (_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.firstName;
    });
    var lastName = computed(function () {
      var _user$value2;
      return user === null || user === void 0 ? void 0 : (_user$value2 = user.value) === null || _user$value2 === void 0 ? void 0 : _user$value2.lastName;
    });
    var email = computed(function () {
      var _user$value3;
      return user === null || user === void 0 ? void 0 : (_user$value3 = user.value) === null || _user$value3 === void 0 ? void 0 : _user$value3.email;
    });
    var orderRef = computed(function () {
      return 'ordRef' + props.idProduct + email.value;
    });
    var linkToSendReviewsForRecipe = computed(function () {
      return constructReviewLink();
    });
    function formatDate(date) {
      var day = date.getDate().toString().padStart(2, '0');
      var month = (date.getMonth() + 1).toString().padStart(2, '0');
      var year = date.getFullYear();
      return "".concat(day, "/").concat(month, "/").concat(year);
    }
    var constructReviewLink = function constructReviewLink() {
      var queryParams = new URLSearchParams({
        'd:Prenom': encodeURIComponent(firstName.value),
        'd:Adresse_email_client': email.value,
        'd:date_d_achat': formattedDate.value,
        'd:nom': encodeURIComponent(lastName.value),
        'd:country_code': encodeURIComponent(convertLocaleEnToUk(locale)).toUpperCase(),
        'd:order_ref': encodeURIComponent(orderRef.value),
        'd:request_date': formattedDate.value,
        'd:content_bcl[0][product_name]': props.nameProduct,
        'd:content_bcl[0][product_ref]': encodeURIComponent(props.idProduct),
        'lang': encodeURIComponent(locale),
        'd:content_bcl[0][content_type]': 'recipe'
      });
      return "https://room.myfeelback.com/website/".concat(encodeURIComponent(tokenWidgets), "/fullPage?").concat(queryParams.toString());
    };
    function sendReviews(event) {
      doActionOrLogin({
        nextRoutePath: route.path,
        previousRoutePath: route.path,
        action: function () {
          var _action = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var events, eventCurrentTarget;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  events = event;
                  eventCurrentTarget = event.currentTarget;
                  _context.next = 4;
                  return loadScript(events, eventCurrentTarget);
                case 4:
                  openModal(events, eventCurrentTarget);
                case 5:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function action() {
            return _action.apply(this, arguments);
          }
          return action;
        }()
      });
    }
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var isWidgetGenerated, observer;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return loadSkeepers();
          case 2:
            _context2.next = 4;
            return generateWidget();
          case 4:
            isWidgetGenerated = _context2.sent;
            nextTick(function () {
              isSkeeperLoaded.value = isWidgetGenerated;
            });
            observer = new MutationObserver(function () {
              var _skeepersWidget$value;
              if ((_skeepersWidget$value = skeepersWidget.value) !== null && _skeepersWidget$value !== void 0 && _skeepersWidget$value.childElementCount) {
                isReviewWidgetDisplayed.value = true;
                observer.disconnect();
              }
            });
            if (skeepersWidget.value) {
              observer.observe(skeepersWidget.value, {
                childList: true,
                subtree: true
              });
            }
            isClientReady.value = true;
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    onBeforeUnmount(function () {
      isReviewWidgetDisplayed.value = false;
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      loadSkeepers: loadSkeepers,
      generateWidget: generateWidget,
      route: route,
      doActionOrLogin: doActionOrLogin,
      $flag: $flag,
      locale: locale,
      isClientReady: isClientReady,
      user: user,
      translate: translate,
      date: date,
      nameOfPage: nameOfPage,
      tokenWidgets: tokenWidgets,
      isMainNewReviewEnabled: isMainNewReviewEnabled,
      isReviewWidgetDisplayed: isReviewWidgetDisplayed,
      verifyKeyExists: verifyKeyExists,
      isSkeeperLoaded: isSkeeperLoaded,
      skeepersWidget: skeepersWidget,
      formattedDate: formattedDate,
      isNotEmpty: isNotEmpty,
      isPageIncluded: isPageIncluded,
      firstName: firstName,
      lastName: lastName,
      email: email,
      orderRef: orderRef,
      linkToSendReviewsForRecipe: linkToSendReviewsForRecipe,
      formatDate: formatDate,
      constructReviewLink: constructReviewLink,
      sendReviews: sendReviews,
      CardRatingAndReviews: CardRatingAndReviews,
      AzButton: AzButton,
      AzIcon: AzIcon
    };
  }
});